<div class="message--loading">
    <img src="../../../assets/img/loading-dark.svg" />
</div>
